export default function (prefix) {
  return {
    configInfo: prefix + '/satisfaction/config/visitor/configInfo', // 满意度配置
    saveSatisfaction: prefix + '/satisfaction/saveSatisfaction', // 保存满意度
  }
}
